// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>21</span>&nbsp;&nbsp;&#145;These things have you done, and should I keep silence?&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;Did you think that I am even such a one as yourself?<br> </p> </div></div>";
// Exports
module.exports = code;